import React from "react";
import { Helmet } from "react-helmet-async";

const PrivacyAndPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Vinayak24x7 Privacy Policy | Jaipur Vinayakanic</title>
        <meta
          name="description"
          content="Read the Privacy Policy for using our 24x7 car breakdown and roadside assistance service in Jaipur."
        />
        <link rel="canonical" href="https://vinayak24x7jaipur.com/terms" />
      </Helmet>
      <div className="main-content" style={{ textAlign: "justify" }}>
        {/* Section: Blog */}
        <section className="my-5">
          <div className="container ">
            <h1
              className="title mb-5 text-center"
              style={{
                fontWeight: "900",
                color: "#f9a602",
              }}
            >
              Privacy Policy
            </h1>
            <div className="row">
              <div className="col-md-12 blog-pull-right">
                <div className="single-service">
                  <h3 className="text-theme-colored">Privacy Policy</h3>
                  <p>We care about your personal data</p>
                  <p>
                    <strong>Vinayak 24x7</strong>&nbsp; providing various
                    assistance products and services within India and on a
                    cross-border basis. Protecting your privacy is a top
                    priority for us. This privacy notice explains how and what
                    type of personal data will be collected, why it is collected
                    and to whom it is shared or disclosed. Please read this
                    notice carefully.
                  </p>
                  <p>1. Who is the data controller?</p>
                  <p>
                    A data controller is an individual or legal person who
                    controls and is responsible to keep and use personal data in
                    paper or electronic files.&nbsp;
                    <strong>Vinayak 24x7 Assistance</strong>&nbsp; [is]/[are]
                    the data controller as defined by relevant data protection
                    laws and regulations.
                  </p>
                  <p>&nbsp;</p>
                  <p>2. What personal data will be collected?</p>
                  <p>
                    We will collect and process various types of personal data
                    about you as follows:
                  </p>
                  <ul>
                    <li>Surname, first name</li>
                    <li>Address</li>
                    <li>Date of birth</li>
                    <li>Gender</li>
                    <li>Identification document number</li>
                    <li>Telephone numbers</li>
                    <li>Email address</li>
                    <li>Lifestyle and other information</li>
                    <li>
                      Vehicle information - make, model, variant, manufacturing
                      year, registration number
                    </li>
                  </ul>
                  <p>3. How will we obtain and use your personal data?</p>
                  <p>
                    We will collect and use the personal data that you provide
                    to us [and that we receive above you (as explained below)]
                    for several purposes and with your express consent unless
                    applicable laws and regulations do not require us to obtain
                    your express consent, as shown below:
                  </p>
                  <table>
                    <thead>
                      <tr>
                        <td style={{ height: 5, width: 340 }}>
                          <p>
                            <strong>Purpose</strong>
                          </p>
                        </td>
                        <td style={{ height: 5, width: 340 }}>
                          <p>
                            <strong>Your express consent?</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            &nbsp;• Roadside Assistance contract administration
                          </p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            Yes, where needed. However, where we need to process
                            your data to underwrite your policy and/or process
                            your claim we will not obtain your express consent.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>&nbsp;• To administer debt recoveries.</p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <p>&nbsp;• No</p>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            &nbsp;• To inform you, or permit Vinayak and
                            selected third parties to inform you, about products
                            and services we feel may interest you in accordance
                            with your marketing preferences. You can change
                            these at any time by contacting us.
                          </p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <p>&nbsp;• Yes</p>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            &nbsp;• For automated decision making (including
                            profiling), to personalize your experience [on the
                            website] (by presenting products, services,
                            marketing messages, offers, and content tailored to
                            you), and to make other decisions about you using
                            computerized technology such as assessing which
                            products might be most suitable for you.
                          </p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <table
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            style={{ width: 324 }}
                          >
                            <tbody>
                              <tr>
                                <td style={{ height: 102 }}>
                                  <p>
                                    &nbsp;• Yes, where needed. However, where we
                                    need to process your data to underwrite your
                                    policy and/or process your claim we will not
                                    obtain your express consent.
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>&nbsp;• Fraud prevention and detection.</p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <table
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            style={{ width: 32 }}
                          >
                            <tbody>
                              <tr>
                                <td style={{ height: 20 }}>
                                  <p>&nbsp;• No</p>
                                </td>
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            &nbsp;• Meet any legal obligations (e.g., tax,
                            accounting, and administrative obligations).
                          </p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <table
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            style={{ width: 32 }}
                          >
                            <tbody>
                              <tr>
                                <td style={{ height: 20 }}>
                                  <p>&nbsp;• No</p>
                                </td>
                              </tr>
                              <tr>
                                <td>&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ height: 11, width: 340 }}>
                          <p>
                            &nbsp;• To redistribute risk by means of reinsurance
                            and co-insurance.
                          </p>
                        </td>
                        <td style={{ height: 11, width: 340 }}>
                          <p>&nbsp;• No</p>
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <p>&nbsp;</p>
                  <p>
                    As mentioned above, for the purposes indicated above, we
                    will process the personal data we receive about you while
                    registering.
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    For those purposes indicated above where we have indicated
                    that we do not require your express consent or where we
                    otherwise require your data to assist and service you and/or
                    process your claim, we will process your data based on our
                    legitimate interests and/or to comply with our legal
                    obligations.
                  </p>
                  <p>
                    We will need your data if you would like to purchase our
                    products and services. If you do not wish to provide this to
                    us, we may not be able to provide the products and services
                    you request, that you may be interested in, or tailor our
                    offerings to your particular requirements.
                  </p>
                  <p>&nbsp;</p>
                  <p>4. Who will have access to your personal data?</p>
                  <p>
                    We will ensure that your data is processed in a manner that
                    is compatible with the purposes indicated above.
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    For the stated purposes, your personal data may be disclosed
                    to the following parties who operate as third party data
                    controllers.
                  </p>
                  <p>
                    Public authorities, other Vinayak 3rd&nbsp;party partners,
                    and banks
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    For the stated purposes, we may also share your personal
                    data with the following parties who operate as data
                    processors under our instruction.
                  </p>
                  <p>
                    Other Vinayak, technical consultants, experts, lawyers, loss
                    adjusters, repairers, medical doctors, and service companies
                    to discharge operations (claims, IT, postal, document
                    management).
                  </p>
                  <p>
                    Advertisers and advertising networks to send you marketing
                    communications, as permitted under local law and in
                    accordance with your communication preferences. We do not
                    share your personal data with non-affiliated third parties
                    for their own marketing use without your permission.
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    Finally, we may share your personal data in the following
                    instances:
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    • In the event of any contemplated or actual reorganization,
                    merger, sale, joint venture, assignment, transfer, or other
                    disposition of all or any portion of our business, assets,
                    or stock (including in any insolvency or similar
                    proceedings).
                  </p>
                  <p>
                    To meet any legal obligation, including to the relevant
                    ombudsman if you make a complaint about the product or
                    service we have provided to you.
                  </p>
                  <p>&nbsp;</p>
                  <p>5. Where will my personal data be processed?</p>
                  <p>
                    Your personal data may be processed both inside and outside
                    of the European Economic Area (EEA) by the parties specified
                    in section 4 above, subject always to contractual
                    restrictions regarding confidentiality and security in line
                    with applicable data protection laws and regulations. We
                    will not disclose your personal data to parties who are not
                    authorized to process them.
                  </p>
                  <p>
                    Whenever we transfer your personal data for processing
                    outside of the EEA by Vinayak, we will do so on the basis of
                    Vinayak approved Binding Corporate Rules known as
                    Vinayak24x7 which establish adequate protection for personal
                    data and are legally binding on Vinayak. Vinayak comply with
                    them can be accessed here&nbsp;https://www.vinayak24x7.com/
                    .Where Vinayak does not apply, we will instead take steps to
                    ensure that the transfer of your personal data outside of
                    the EEA receives an adequate level of protection as it does
                    in the EEA. You can find out what safeguards we rely upon
                    for such transfers (for example, Standard Contractual
                    Clauses) by contacting us as detailed in section 9 below.
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    6. What are your rights in respect of your personal data?
                  </p>
                  <p>
                    Where permitted by applicable law or regulation, you have
                    the right to:
                  </p>
                  <ul>
                    <li>
                      Access your personal data held about you and to learn the
                      origin of the data, the purposes and ends of the
                      processing, the details of the data controller(s), the
                      data processor(s), and the parties to whom the data may be
                      disclosed.
                    </li>
                    <li>
                      Withdraw your consent at any time where your personal data
                      is processed with your consent;
                    </li>
                    <li>
                      Update or correct your personal data so that it is always
                      accurate.
                    </li>
                    <li>
                      Delete your personal data from our records if it is no
                      longer needed for the purposes indicated above.
                    </li>
                    <li>
                      Restrict the processing of your personal data in certain
                      circumstances, for example where you have contested the
                      accuracy of your personal data, for the period enabling us
                      to verify its accuracy.
                    </li>
                    <li>
                      Obtain your personal data in an electronic format for you
                      or for your new insurer.
                    </li>
                    <li>
                      File a complaint with us and/or the relevant data
                      protection authority.
                    </li>
                  </ul>
                  <p>
                    You may exercise these rights by contacting us as detailed
                    in section 9 below providing your name, email address,
                    account identification, and purpose of your request.
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    7. How can you object to the processing of your personal
                    data?
                  </p>
                  <p>
                    Where permitted by applicable law or regulation, you have
                    the right to object to us processing your personal data or
                    tell us to stop processing it (including for purposes of
                    direct marketing). Once you have informed us of this
                    request, we shall no longer process your personal data
                    unless permitted by applicable laws and regulations.
                  </p>
                  <p>
                    You may exercise this right in the same manner as for your
                    other rights indicated in section 6 above.
                  </p>
                  <p>&nbsp;</p>
                  <p>8. How long do we keep your personal data?</p>
                  <p>
                    We will retain your personal data for ten years from the
                    date the policy ends unless a longer retention period is
                    required or as permitted by law OR specifically as detailed
                    below.
                  </p>
                  <p>
                    We will not retain your personal data for longer than
                    necessary and we will hold it only for the purposes for
                    which it was obtained.
                  </p>
                  <p>&nbsp;</p>
                  <p>9. How can you contact us?</p>
                  <p>
                    If you have any queries about how we use your personal data,
                    you can contact us by telephone, email, or post as follows.
                  </p>
                  <p>&nbsp;</p>
                  <p>Vinayak 24x7,</p>
                  <p>
                    Plot No.7, Bajrang Vihar Rd, near Durgapura Railway Station,
                    above CK BIRLA HOSPITAL, Shanti Nagar, Durgapura, Jaipur,
                    Rajasthan 302018 &nbsp;
                    <br />
                    Email:&nbsp;
                    <a href="mailto:privacy@vinayak24x7.com">
                      privacy@vinayak24x7.com
                    </a>
                    <br />
                    Phone: 6367607678
                  </p>
                  <p>&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrivacyAndPolicy;
